import React, { useEffect, useState } from 'react';

import { formatFigure } from 'Helpers/formatService';

import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

// Figures render as stored, so the floor sits below any precision they carry.
const formatRaw = (value) => formatFigure(value, String, { precision: 4 });

export default function CommitmentModal(props) {
    const [maxAmountDataLength, setMaxAmountDataLength] = useState(0);
    useEffect(() => {
        setMaxAmountDataLength(
            (props.committedExpensables || []).reduce((maxLength, commitment) => {
                const filteredLength = Object.keys(commitment.amount_data || {}).filter((key) => key !== 'Price').length;
                return Math.max(maxLength, filteredLength);
            }, 0),
        );
    }, [props.committedExpensables]);

    const getGap = (commitment) => {
        return maxAmountDataLength - Object.keys(commitment.amount_data).filter((key) => key !== 'Price').length;
    };

    return (
        <Modal id={props.id} modal={props.modal} parentContainerClasses="!tw-max-w-7xl">
            <ModalHeader title={$t('Commitments')} close={props.onClose}></ModalHeader>
            <div className="tw-rounded-b">
                {props.committedExpensables && (
                    <div className="tw-flex tw-flex-col tw-my-4 tw-w-full">
                        <div className="inbud-table_wrapper">
                            <table id="committed-table" className="inbud-table tw-table-fixed">
                                <thead>
                                    <tr>
                                        <th>{$t('Supplier')}</th>
                                        <th>{$t('Contract')}</th>
                                        <th>{$t('Price')}</th>
                                        {/* Dynamic Quantity and Description columns */}
                                        {!!maxAmountDataLength &&
                                            [...Array(maxAmountDataLength).keys()].map((index) => (
                                                <React.Fragment key={index}>
                                                    <th>
                                                        {$t('Quantity')} {index + 1}
                                                    </th>
                                                    <th>{$t('Description')}</th>
                                                </React.Fragment>
                                            ))}
                                        <th>{$t('Total')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.committedExpensables.map((commitment, index) => (
                                        <tr key={index}>
                                            {/* Supplier */}
                                            <td>{commitment.supplier?.name || '-'}</td>

                                            {/* Contract */}
                                            <td>{commitment.supplier_contract ? <a href={`#`}>{commitment.supplier_contract.contract_reference}</a> : '-'}</td>

                                            {/* Price */}
                                            <td>{formatRaw(commitment.price)}</td>

                                            {/* Amount Data (Quantity and Description) */}
                                            {commitment.amount_data
                                                ? Object.entries(commitment.amount_data).map(
                                                      ([key, value], i) =>
                                                          key !== 'Price' && (
                                                              <React.Fragment key={i}>
                                                                  <td>{formatRaw(value)}</td>
                                                                  <td>{key}</td>
                                                              </React.Fragment>
                                                          ),
                                                  )
                                                : null}

                                            {/* Render the remaining gap columns */}
                                            {getGap(commitment) > 0 &&
                                                Array.from({ length: getGap(commitment) }).map((_, index) => (
                                                    <React.Fragment key={index}>
                                                        <td></td>
                                                        <td></td>
                                                    </React.Fragment>
                                                ))}

                                            {/* Total */}
                                            <td>{formatRaw(commitment.cashflow?.total)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    );
}
